<template>
  <div class="lesspricerequest-component">

    <button
      data-bs-toggle="modal"
      data-bs-target="#priceDeliveryModal"
      class="btn btn--surface-dim product-services__btn">
      
      <i class="fa fa-truck product-services__icon"></i>
      <span class="product-services__text-btn">Рассчитать доставку</span>
    </button>

    <div class="modal fade" id="priceDeliveryModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal__dialog">
        <div class="modal-content modal-dialog__content">
          <div class="modal-header modal-content__header">
            <h5 class="modal-title modal-header__title" id="priceDeliveryModalLabel">Запрос скидки</h5>
            <button type="button" class="close modal-header__close-btn" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body modal-content__body">
            <p>Укажите параметры доставки, и мы предложим самый выгодный вариант.</p>
            <product-simple
              v-if="product"
              :product="product"></product-simple>

            <delivery-price-request-form
              v-if="contact && step=='form'"
              @send-form="sendForm"
              :contact="contact"
              :errors="errors"
              class="mt-4"></delivery-price-request-form>

            <div v-if="step == 'complete'">
              <p class="text-success">
                Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import UtilsMixin from '../vue_mixins/UtilsMixin.vue'
import FormMixin from '../vue_mixins/FormMixin.vue'

import ProductSimple from './ProductSimple.vue'
import DeliveryPriceRequestForm from './DeliveryPriceRequestForm.vue'

export default {

  name: 'DeliveryPriceRequest',
  mixins: [UtilsMixin, FormMixin],

  props: {
    objectId: {
      type: Number,
      default: null
    },
    contentType: {
      type: Number,
      default: null
    }
  },

  components: {
    ProductSimple,
    DeliveryPriceRequestForm
  },

  data() {
    return {
      product: null,
      contact: null,
      step: 'form',
      errors: {}
    }
  },

  mounted() {
    this.initData()
    if (this.objectId) {
      this.loadProduct()
    }

  },

  methods: {
    loadProduct () {
      axios.get(`/catalog/api/product/${this.objectId}/`).then(
        response => {
          this.product = response.data
        }
      )
    },

    initData() {
      axios.get("/contacts/api/delivery-price-request/").then(
        response => {
          this.contact = response.data
          this.contact.content_type = this.contentType
          this.contact.object_id = this.objectId
        })
        this.errors = {}
        this.step = 'form'
    },

    sendForm (contactData) {
      this.contact = contactData
      axios.put("/contacts/api/delivery-price-request/", this.contact)
        .then(response => {
          this.contact = response.data
          this.step = 'complete'
          if (typeof ym === 'function' && this.ymCounterId) {
            ym(this.ymCounterId, 'reachGoal', 'DELIVERY_PRICE_MESSAGE')
          }
          else {
            console.log(`YM params undefined this.ymCounterId ${this.ymCounterId}`)
          }
          
          this.errors = {}
        })
        .catch(error => {
          this.errors = error.response.data
        });
    }
  },

}
</script>


<style lang="scss"></style>
